export default [
  {
    path: '/onboarding-v2',
    component: () => import('@/feature/onboarding-v2/views/OnboardingWrapper.vue'),
    name: 'v2-onboarding-wrapper',
    children: [
      {
        path: '/onboarding-v2/confirmacao',
        component: () => import('@/feature/onboarding-v2/views/OnboardingConfirmation.vue'),
        name: 'v2-onboarding-confirmation',
      },
      {
        path: '/onboarding-v2/documentos',
        component: () => import('@/feature/onboarding-v2/views/OnboardingDocuments.vue'),
        name: 'v2-onboarding-documents',
      },
      {
        path: '/onboarding-v2/documentos/:documentStep/camera',
        component: () => import('@/feature/onboarding-v2/views/OnboardingDocumentsCamera.vue'),
        name: 'v2-onboarding-documents-camera',
      },
      {
        path: '/onboarding-v2/selfie',
        component: () => import('@/feature/onboarding-v2/views/OnboardingSelfie.vue'),
        name: 'v2-onboarding-selfie',
      },
      {
        path: '/onboarding-v2/selfie/camera',
        name: 'v2-onboarding-selfie-camera-facetec',
        component: () => import('@/feature/onboarding-v2/views/OnboardingSelfieFacetecCamera.vue'),
      },
      {
        path: '/onboarding-v2/selfie/parcelex/camera',
        name: 'v2-onboarding-selfie-camera-parcelex',
        component: () => import('@/feature/onboarding-v2/views/OnboardingSelfieCamera.vue'),
      },
      {
        path: '/onboarding-v2/selfie/erro',
        name: 'v2-onboarding-facetec-error',
        component: () => import('@/feature/onboarding-v2/views/OnboardingFacetecError.vue'),
      },
      {
        path: '/onboarding-v2/analise',
        component: () => import('@/feature/onboarding-v2/views/OnboardingDesk.vue'),
        name: 'v2-onboarding-desk',
      },
      {
        path: '/onboarding-v2/entrada',
        component: () => import('@/feature/onboarding-v2/views/OnboardingDownPayment.vue'),
        name: 'v2-onboarding-entry',
      },
      {
        path: '/onboarding-v2/seguro',
        name: 'v2-onboarding-insurance',
        component: () => import('@/feature/onboarding-v2/views/OnboardingInsurance.vue'),
      },
      {
        path: '/onboarding-v2/assinatura',
        name: 'v2-onboarding-signature',
        component: () => import('@/feature/onboarding-v2/views/OnboardingSignature.vue'),
      },
      {
        path: '/onboarding-v2/contrato',
        name: 'v2-onboarding-signature-contract-view',
        component: () => import('@/feature/onboarding-v2/views/OnboardingContractView.vue'),
      },
      {
        path: '/onboarding-v2/completo',
        component: () => import('@/feature/onboarding-v2/views/OnboardingComplete.vue'),
        name: 'v2-onboarding-complete',
      },
      {
        path: '/onboarding-v2/aviso-celular',
        component: () => import('@/feature/onboarding-v2/views/OnboardingRedirectToMobile.vue'),
        name: 'v2-onboarding-redirect-to-mobile',
      },
      {
        path: '/onboarding-v2/error/camera/android',
        name: 'v2-onboarding-error-camera-android',
        component: () => import('@/feature/onboarding-v2/views/OnboardingErrorCameraAndroid.vue'),
      },
      {
        path: '/onboarding-v2/error/camera/ios',
        name: 'v2-onboarding-error-camera-ios',
        component: () => import('@/feature/onboarding-v2/views/OnboardingErrorCameraIos.vue'),
      },
      {
        path: '/onboarding-v2/error',
        name: 'v2-onboarding-error',
        component: () => import('@/views/Error.vue'),
      },
    ],
  },
];
